import React, {useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {translation} from "../../../../I18n/i18n";
import classes from "../ProfessionalExperiences/WorkExperience/Experience.module.css";
import SpellChecker from "../../../UI/SpellChecker/SpellChecker";
import Grid from "@mui/material/Grid";
import Button from "../../../UI/Button/Button";



const EducationTrainingContent = (props) => {
    const [year, setYear] = useState(props.section ? props?.section?.year?._text : "");
    const [title, setTitle] = useState(props.section ? props?.section?.title?._text : "");
    const [location, setLocation] = useState(props.section ? props?.section?.location?._text : "");
    function isValidYear(year) {
        // check if the input string is 4 characters long
        const isCorrectLength = year.length === 4;
        // check if the input string is a number
        const isNumeric = /^\d+$/.test(year);
        return isCorrectLength && isNumeric;
    }
    let isSaveBtnDisabled = () => {
        //Disable if code , level is not defined
        let valid = title?.length > 0 && year?.length>0 && isValidYear(year);
        return !valid;
    }
    return (
<>
    <Form>
        <Form.Group as={Row}>
            <Form.Label column sm="1">{translation(props.lang, "Title")}
                <span className={classes.required}>*</span>
            </Form.Label>
            <Col sm="11">
                <SpellChecker
                    dict={props.dict}
                    notify={props.notify}
                    addToDictionary={props.addToDictionary}
                    lang={props.lang}
                    value={title}
                    onChange={(v) => {
                        setTitle(v)
                    }}
                />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label column sm="1">{translation(props.lang, "Location")}
            </Form.Label>

            <Col sm="7">
                <SpellChecker
                    dict={props.dict}
                    notify={props.notify}
                    addToDictionary={props.addToDictionary}
                    lang={props.lang}
                    value={location}
                    onChange={(v) => {
                        setLocation(v)
                    }}
                />
            </Col>
            <Form.Label column sm="1">{translation(props.lang, "Year")}
                <span className={classes.required}>*</span>
            </Form.Label>
            <Col sm="3">
                <SpellChecker
                    dict={props.dict}
                    notify={props.notify}
                    addToDictionary={props.addToDictionary}
                    lang={props.lang}
                    value={year}
                    onChange={(v) => {
                        setYear(v)
                    }}
                />
            </Col>
        </Form.Group>
    </Form>
    <Grid  container spacing={3}>
        <Grid item xs={10}></Grid>
        <Grid item xs={1} style={{padding: '20px 2px 20px 2px'}}>
            <Button
                label={translation(props.lang, props.buttonTitle)}
                isDisabled={isSaveBtnDisabled()}
                variant="success"
                isVisible={true}
                size="sm"
                loading={props.loading}
                actionHandler={() => {
                    props.section.year = {_text: year };
                    props.section.title = {_text: title };
                    props.section.location = {_text: location }
                    props.submit()
                }}
            />
        </Grid>
        <Grid item xs={1} style={{padding: '20px 0px 2px 2px'}}>
            <Button
                label={translation(props.lang, "Cancel")}
                variant="danger"
                isVisible={true}
                size="sm"
                loading={props.loading}
                actionHandler={props.cancel}/>
        </Grid>
    </Grid>
</>
    );
};

export default EducationTrainingContent;
